export default {
  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    search: '検索',
    save: '保存',
    delete: '削除',
    edit: '編集',
    more: 'もっと見る',
    loading: '読み込み中...',
    noData: 'データなし',
    backToHome: 'ホームに戻る',
    follow: 'フォロー',
    alreadyFollow: 'locale.alreadyFollow',
    unFollow: 'locale.unFollow',
    openAppDetails: '詳細はアプリで',
  },
  validation: {
    required: '{field}は必須です',
    email: '有効なメールアドレスを入力してください',
    phone: '有効な電話番号を入力してください',
  },
  error: {
    networkError: 'ネットワークエラー、接続を確認してください',
    serverError: 'サーバーエラー、後でもう一度お試しください',
    notFound: 'ページが見つかりません',
  },
  // 卡组分享
  deckShare: {
    userId: 'id: {id}',
    stats: {
      cards: 'カード',
      pokemon: 'ポケモン',
      trainers: 'トレーナー',
      energy: 'エネルギー',
    },
    gameInfo: {
      type: 'ゲームタイプ',
      format: 'スタンダード',
    },
    userAvatar: 'ユーザーアバター',
    cardName: 'カード名',
  },
  // 推荐栏
  appPromotion: {
    logoAlt: 'アプリアイコン',
    openApp: 'アプリを開く',
    downloadApp: 'アプリをダウンロード',
    openInBrowser: 'ブラウザで開いてダウンロードしてください',
    cardTrade: 'カード取引',
    topDeck: '上位カードグループ',
    priceEvaluation: '競争送評',
    cardCommunity: 'カードコミュニティ',
    gameTeaching: 'ゲーム解説'
  },
  // 银行卡添加
  addBankCard: {
    cardNumber: 'カード番号',
    expirationDate: '有効期限',
    cvv: 'セキュリティコード',
    cvvTip: '桁の数字',
    submit: '追加を確認',
    support: '対応カードブランド',
    safeTip: 'お客様の情報は暗号化され、安全に保護されています',
    confirm: '確認',
    dateTip: '有効期限を選択してください',
    cardTip: 'カード番号を入力してください',
    invalidCardLength: 'カード番号をご確認ください',
    unsupportedCard: '現在このカードブランドには対応していません',
  },
  // 搜索榜单
  searchRanking: {
    hotCard: '人気のカード',
    priceIncrease: '値上がりランキング',
  },
  // 个人主页
  userProfile: {
    userAvatar: 'ユーザーアバター',
    userId: 'id: {id}',
    gameTags: "I'm playing",
    stats: {
      decks: 'デッキ',
      followers: 'フォロワー',
      following: 'フォロー',
      posts: '投稿',
    },
  },
  // 卡包分享
  packShare: {
    increaseList: '値上がりランキング',
    rating: '評価',
    reviews: '評価',
    including: '含むカード',
    cardPriceFrom: 'から',
    cards: '枚のカード',
    sharePack: 'パックを共有',
  },
  // 卡片详情页
  cardDetail: {
    increaseList: '値上がりランキング',
    products: '商品',
    effectQA: '効果/QA',
    decks: 'デッキ',
    reviews: '評価',
    other: 'その他',
    priceGuarantee: '価格は公平に保障されている',
    lastMonth: '最近1ヶ月',
    appDetail: '詳細はアプリで',
    condition: 'コンディション',
    priceTrade: '集換価格',
    priceTrend: {
      up: '上昇',
      down: '下落'
    },
    currentPrice: '現在の価格',
  },
  // 分享
  share: {
    priceTrend: '価格推移',
    strategyInfo: '攻略情報',
    deckConstruction: 'デッキ構築',
    appDetail: '詳細はアプリで',
    scanQR: 'QRコードをスキャンして',
    cardEverything: 'トレカの新世界を見つけよう!',
  },
  // 店铺
  shop: {
    userId: 'ユーザーID: {id}',
    products: '商品',
    buyers: '買い手',
    followers: 'フォロワー',
  },
  // 心愿单
  wish: {
    wishCount: '枚',
    wishTips: '今すぐ買ってバトル！',
  },
  // 卡册
  cardAlbum: {
    hi: 'Hi, 我是{username}',
    desc: '这是我在集换社上拥有的集换卡册~',
    cardCount: 'カード数',
    totalInvestment: '総投資額',
    currentExchangePrice: '現在の集換価格総額',
    syncTitle: '集換社でカードを収集し、図鑑を整理しましょう~',
    startExchange: '集換之旅を開始',
  },
};
